module.exports = __webpack_public_path__ + "img/芒果9.ff4118d8.png";